import { CitationBadge } from 'components/ui/CitationBadge'
import { CitationSource } from 'types/chat-message'

type SourceCitationProps = {
  num: string
  source: CitationSource
}

/** Inline citation for a remote source ([N]): a clickable badge, or a neutral one when it has no url. */
export const SourceCitation = ({ num, source }: SourceCitationProps) => {
  const href =
    source.type === 'site'
      ? (source.pageUrl ?? source.url ?? '')
      : (source.url ?? '') + (source.page != null ? `#page=${source.page}` : '')

  const title = source.name + (source.page != null ? ` (p. ${source.page})` : '')

  if (href) {
    return <CitationBadge label={num} href={href} title={title} className="tw-align-super tw-mx-[1px]" />
  }

  return <CitationBadge label={num} variant="neutral" title={source.name} className="tw-align-super tw-mx-[1px]" />
}
